import { render, staticRenderFns } from "./MarketingPlanObjects.vue?vue&type=template&id=bffd6de6&scoped=true"
import script from "./MarketingPlanObjects.vue?vue&type=script&lang=js"
export * from "./MarketingPlanObjects.vue?vue&type=script&lang=js"
import style0 from "./MarketingPlanObjects.vue?vue&type=style&index=0&id=bffd6de6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffd6de6",
  null
  
)

export default component.exports